<template>
  <Modal modalName="exportGraphModal" title="Zapisz graf sieci do pliku *.inp" :buttons="[]"></Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({})
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/ExportGraph.vue